import Asset from './Asset';

const resolveAssetActions = value => ({
    updateAsset(nextAsset) {
        Object.assign(value, new Asset(), nextAsset);
    },
});

export default resolveAssetActions;
